import { useTranslation } from 'react-i18next';
import { KoobButton, KoobEmptyState } from '@koob/ui';

// Without the connection request the page cannot show who is connected nor
// save anything, so it replaces the editor instead of rendering it empty.
export default function RequestLoadError({ onRetry }) {
  const { t } = useTranslation('toConnectionRequest');

  return (
    <div className="p-4">
      <KoobEmptyState
        icon={<i className="fa-light fa-triangle-exclamation text-2xl" />}
        title={t('loadError')}
        description={t('loadErrorDescription')}
      >
        <KoobButton
          variant="secondary"
          className="border-none"
          onClick={onRetry}
        >
          {t('retry')}
        </KoobButton>
      </KoobEmptyState>
    </div>
  );
}
